import { render, staticRenderFns } from "./PresencasPage.vue?vue&type=template&id=3993eac8&scoped=true"
import script from "./PresencasPage.vue?vue&type=script&lang=js"
export * from "./PresencasPage.vue?vue&type=script&lang=js"
import style0 from "./PresencasPage.vue?vue&type=style&index=0&id=3993eac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993eac8",
  null
  
)

export default component.exports